// extracted by mini-css-extract-plugin
export default {"boxcontent":"JP_About_boxcontent__Ck-4I"};